import React from "react";
import { motion } from "framer-motion";
import { sectionVariants, staggerContainer, itemVariants } from "../../constants/animations";
import { INTERESTS } from "./Interests.constants";

const Interests: React.FC = () => {
  return (
    <motion.section
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="py-20 px-6 bg-slate-800/30"
    >
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-8 gradient-text">
          Interests & Hobbies
        </h2>
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="flex flex-wrap justify-center gap-4"
        >
          {INTERESTS.map((interest) => (
            <motion.span
              key={interest}
              variants={itemVariants}
              whileHover={{ scale: 1.1 }}
              className="px-6 py-3 rounded-full glass text-slate-300 hover:text-white transition-colors cursor-default"
            >
              {interest}
            </motion.span>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Interests;
